import { getAxios } from '@parchment/oauth2-axios';
import { ADDRESS_VERIFICATION_API_RESOURCE_KEY } from './constants';
export default async function getAutocompleteAddress(_ref) {
  let {
    address1: prefix,
    city: cityFilter,
    state: stateFilter,
    suggestions = 3
  } = _ref;
  let root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  const params = {
    prefix,
    stateFilter,
    cityFilter,
    suggestions
  };
  const response = await getAxios(ADDRESS_VERIFICATION_API_RESOURCE_KEY).get(`${root}address/autocomplete`, {
    params
  });
  return response.data || [];
}